import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from '../common/DropdownList';
import InfoTooltip from '../common/InfoTooltip';
import AddFeedback from './AddFeedback';
import { formatCurrency } from '../../numberUtils';

function LineItems({
  category,
  lineItemsGroupName,
  descriptionLabel,
  hasDuration,
  lineItems,
  totalPay,
  totalTime,
  updateLineItemFeedback,
  isValid,
  viewerIsEmployer,
}) {
  return (
    <div className={`line-items card p-5 border-0 ${isValid ? '' : 'not-valid'}`}>
      <div className="request-edits-line-items body-text-2">
        <i className="fa fa-edit" />
        Request line-by-line edits here:
      </div>
      <div className="card-body px-5">
        <div className={`${category}-line-items`}>
          <DropdownList
            title={lineItemsGroupName}
            dropdownClass={hasDuration ? `${category}-hours` : `${category}s`}
            isSideBySide
            icon="caret"
          >
            <div className="header g-row--always">
              <div className="date">Date</div>
              <div className="optional-id">
                Optional ID
                <InfoTooltip
                  triggerClassName="optional-id-tooltip-trigger"
                  tooltipId="optional-id-tooltip"
                  tooltipPlacement="top"
                  tooltipText="This is an optional field you and your consultant can use to capture project codes/ids, cost centers, or other helpful information."
                />
              </div>
              <div className="description">
                {descriptionLabel}
              </div>
              {hasDuration && <div className="hours-and-minutes">Hours</div>}
              <div className="total">Total</div>
              {!hasDuration && <div className="file" />}
              <div className="actions" />
            </div>
            <div>
              {lineItems && lineItems.map((lineItem, index) => (
                <AddFeedback
                  {...lineItem}
                  total={viewerIsEmployer ? lineItem.gross_total : lineItem.total}
                  index={index}
                  key={lineItem.id}
                  hasDuration={hasDuration}
                  updateLineItemFeedback={updateLineItemFeedback}
                />
              ))}
            </div>
            <div className="totals g-row--always">
              <div className="spacer1" />
              <div className="line-item-category-total">
                Total
                {hasDuration ? category : `${category}s`}
              </div>
              {hasDuration
              && (
              <div className="line-item-time">
                {totalTime.hours}
                {' '}
                h.
                {totalTime.minutes}
                {' '}
                min.
              </div>
              )}
              <div className="line-item-total">{formatCurrency(totalPay)}</div>
              {!hasDuration && <div className="spacer2" />}
            </div>
          </DropdownList>
        </div>
      </div>
    </div>
  );
}

LineItems.propTypes = {
  totalTime: PropTypes.shape({
    hours: PropTypes.number,
    mintues: PropTypes.number,
  }),
  totalPay: PropTypes.number,
  lineItems: PropTypes.shape([]).isRequired,
  lineItemsGroupName: PropTypes.string.isRequired,
  descriptionLabel: PropTypes.string.isRequired,
  hasDuration: PropTypes.bool,
  category: PropTypes.string.isRequired,
  updateLineItemFeedback: PropTypes.func,
  isValid: PropTypes.bool.isRequired,
  viewerIsEmployer: PropTypes.bool.isRequired,
};

LineItems.defaultProps = {
  totalPay: 0,
  totalTime: { hours: 0, minutes: 0 },
  hasDuration: false,
  updateLineItemFeedback: () => null,
};

export default LineItems;
